import { createUseStyles } from 'react-jss';
import { color, spacing } from '@blink/components';

export const useTermsAndConditionStyle = createUseStyles({
    container: {
        width: 808,
        display: 'flex',
        margin: '0 auto',
        flexDirection: 'column',
        gap: '1.5rem',
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
        marginBottom: spacing['09'],
    },
    title: {
        fontSize: '24px',
        marginTop: '48px',
        color: color.content.primary,
        fontFamily: 'Inter',
        fontWeight: 600,
        textAlign: 'center',
    },
    divider: {
        backgroundColor: color.content.inverseSecondary,
    },
    description: {
        color: color.content.secondary,
        textAlign: 'center',
        fontFamily: 'Inter',
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '24px',

        '& strong': {
            color: color.content.primary,
        },
    },
    subtitle: {
        fontSize: '16px !important',
        color: color.content.primary,
        fontWeight: 500,
    },
    text: {
        color: color.content.secondary,
        fontSize: '14px',
        lineHeight: '24px',

        '& strong': {
            color: color.content.primary,
        },
    },
    strong: {
        fontWeight: 500,
    },
    scrollToTop: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        position: 'fixed',
        bottom: '100px',
        right: '20px',
        width: '98px',
        color: color.content.accent,
        cursor: 'pointer',
    },
});
